import { BaseService } from './base-service';
import { NioshReport } from '@/types/Niosh';
import { NioshReportMapper } from '@/core/mappers/niosh-report';
import {
	GetNioshCountHigherRiskFoundParamsDTO,
	GetNioshCountHigherRiskFoundDTO,
	GetNioshReportResponseDTO,
	GetNioshReportRequestDTO
} from '@/core/dto/niosh';

export class NioshReportService extends BaseService {
	private static instance: NioshReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/niosh') {
		super();
	}

	public static getInstance(): NioshReportService {
		if (!NioshReportService.instance) {
			NioshReportService.instance = new NioshReportService();
		}
		return NioshReportService.instance;
	}

	public async getCountHigherRiskFound(
		params: GetNioshCountHigherRiskFoundParamsDTO
	): Promise<GetNioshCountHigherRiskFoundDTO[]> {
		const url = this.basePath + `/risk/count`;
		const { data } = await this.getInstance().get<GetNioshCountHigherRiskFoundDTO[]>(url, { params });
		return data;
	}

	public async getNioshReport(params: GetNioshReportRequestDTO): Promise<NioshReport> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetNioshReportResponseDTO>(url, { params });
		return new NioshReportMapper(data).toDomain();
	}
}
